<mat-sidenav-container class="homepage-sidenav-container">
    <mat-sidenav #sidenav mode="over" opened="false" class="homepage-sidenav-menu" style="position: fixed;"
    (opened)="checkActiveRoute()">
        <div class="content">
            <div class="sidenav-heading heading-h6-regular">
                <img class="logo-image" src="/assets/images/dso-logo.png" alt="dso_logo">
                <span>Procure & Pay</span>
            </div>
            <div class="menu-frame">
                <div class="menu-text paragraph-small-regular">Menu</div>
                <div class="menu-items paragraph-large-regular">
                    <div class="item" (keypress)="navigateToPurchaseMode()" (click)="navigateToPurchaseMode()"
                        [class.active]="currentRoute.includes('/home')">
                        <img class="item-image" src="/assets/images/PurchaseModeImg.svg" alt="Purchase_Mode_img">
                        Purchase Modes
                    </div>
                    <div class="item" (keypress)="navigateToLandingPage()" (click)="navigateToLandingPage()"
                        [class.active]="currentRoute.includes('/land')">
                        <img class="item-image" src="/assets/images/MyDocImg.svg" alt="My_Doc_img">
                        My Documents
                    </div>
                    <div class="item" (keypress)="navigateToWorklistPage()" (click)="navigateToWorklistPage()"
                        [class.active]="currentRoute.includes('/worklist') || currentRoute.includes('/peworklist')">
                        <img class="item-image" src="/assets/images/worklistImg.svg" alt="My_Doc_img">
                        My Worklist
                    </div>
                    <div class="item" (click)="toggleSubMenu()"
                        [class.childActive]="currentRoute.includes('/reports') || currentRoute.includes('/rfqReports')">
                        <img class="item-image" src="/assets/images/Pe-report-img.svg" alt="My_Doc_img">
                        Reports
                        <mat-icon class="expand-icon">{{ isSubMenuOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </div>
                    <div *ngIf="isSubMenuOpen" class="sub-menu">
                        <div class="sub-item" (keypress)="navigateToPEReportsPage()" (click)="navigateToPEReportsPage()"
                            [class.active]="currentRoute.includes('/reports')">
                            Purchasing Executive Report
                        </div>
                        <div class="sub-item" (keypress)="navigateToRFQReportsPage()"
                            (click)="navigateToRFQReportsPage()" [class.active]="currentRoute.includes('/rfqReports')">
                            RFQ Summary Report
                        </div>
                    </div>
                    <div class="item" (click)="toggleLinksSubMenu()">
                        <img class="item-image" src="/assets/images/links.svg" alt="links_img">
                        Useful Links
                        <mat-icon class="expand-icon">{{ isLinksSubMenuOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </div>
                    <div *ngIf="isLinksSubMenuOpen" class="sub-menu">
                        <div class="sub-item" (keypress)="navigateToPPC()" (click)="navigateToPPC()">
                            Price Checker
                        </div>
                        <div class="sub-item" (keypress)="navigateToPriceAgreements()" (click)="navigateToPriceAgreements()">
                            Price Agreements
                        </div>
                    </div>
                    <div class="item" (click)="goToMMS()">
                        <img class="item-image" src="/assets/images/launch.svg" alt="MMS_img">
                        MMS
                    </div>
                </div>
            </div>
        </div>
    </mat-sidenav>
    <app-header (menuToggle)="sidebarToggle()"></app-header>
    <div [style.marginTop.px]="showGlobalNotification ? 64 : 0" [ngClass]="showGlobalNotification ? 'withGlobalBanner' : ''">
        <div class="global-notice" *ngIf="maintenanceMessage!=='' && showGlobalNotification">
            <img class="global-notification-image" src="/assets/images/global-notification.svg"
                alt="global-notification">
            <div class="paragraph-medium-regular notification-content" [innerHTML]="maintenanceMessage"></div>
            <div class="close-notification" (click)="onCloseGlobalNotification()"><mat-icon
                    class="close-icon">close</mat-icon>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-container>